import React from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';
import './map.css';

import MapEvents from './MapEvents';

const DEFAULT_CENTER = [46.4, 10.8];
const DEFAULT_ZOOM = 5;
const MAX_ZOOM = 23;


const LeafletMap = ({ children, center, zoom, onClick, ...props }) => {
	return (
		<div className="map-container">
			<MapContainer center={center} zoom={zoom} {...props}>
				<MapEvents onClick={onClick} />
				<TileLayer
					attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
					url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					maxZoom={MAX_ZOOM}
					maxNativeZoom={19}
				/>
				{children}
			</MapContainer>
		</div>
	);
};

LeafletMap.defaultProps = {
	center: DEFAULT_CENTER,
	zoom: DEFAULT_ZOOM,
	classsName: ''
};

export default LeafletMap;